import { render, staticRenderFns } from "./NotVerified.vue?vue&type=template&id=0d886823&"
import script from "./NotVerified.vue?vue&type=script&lang=js&"
export * from "./NotVerified.vue?vue&type=script&lang=js&"
import style0 from "./NotVerified.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports